import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { updatePassword } from "../../actions/userActions";
import Grid from "@material-ui/core/Grid";
import { TextField } from "@material-ui/core";
import Form from "./Form";

class UpdatePasswordForm extends Component {
  state = {
    oldPassword: "",
    newPassword: "",
    newPasswordConfirmation: "",
  };

  updatePassword = (e) => {
    e.preventDefault();
    this.props.updatePassword(this.props.id, this.state);
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    return (
      <Form
        onSubmit={this.updatePassword}
        submitText="Wijzigen"
        isFetching={this.props.isFetching}
        successMessage={this.props.successMessage}
        errorMessage={this.props.errorMessage}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <TextField
              id="oldPassword"
              name="oldPassword"
              label="Huidig wachtwoord *"
              value={this.state.oldPassword}
              onChange={this.handleChange}
              type="password"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              id="newPassword"
              name="newPassword"
              label="Wachtwoord *"
              value={this.state.newPassword}
              onChange={this.handleChange}
              type="password"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              id="newPasswordConfirmation"
              name="newPasswordConfirmation"
              label="Wachtwoord herhalen *"
              value={this.state.newPasswordConfirmation}
              onChange={this.handleChange}
              type="password"
              fullWidth
            />
          </Grid>
        </Grid>
      </Form>
    );
  }
}

UpdatePasswordForm.propTypes = {
  id: PropTypes.string.isRequired,
  updatePassword: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  successMessage: state.user.updateUserPassword.successMessage,
  errorMessage: state.user.updateUserPassword.errorMessage,
  isFetching: state.user.updateUserPassword.isFetching,
});

export default connect(mapStateToProps, { updatePassword })(UpdatePasswordForm);



// WEBPACK FOOTER //
// ./src/components/forms/UpdatePasswordForm.js